<template>
  <CDropdown placement="auto"
             :visible="visible"
             :disabled="disabled"
             autoClose="outside"
             v-click-outside="hide"
             :class="[
               disabled ? '!tw-opacity-50' : 'tw-cursor-pointer',
               !!errorMessage ? 'tw-border-red-200' : 'tw-border-static-inputBorder'
             ]"
             class="!tw-block tw-relative tw-w-full tw-h-[40px] tw-border tw-p-2 tw-justify-between tw-items-center tw-bg-white !tw-rounded-lg tw-text-blue-dark-500">
    <CDropdownToggle  color="secondary" :caret="false" :custom="true">
      <div class="tw-flex tw-justify-between tw-w-full" @click="toggleDropdown" :class="!disabledSelect && 'tw-group'">
        <div class="tw-flex tw-gap-2 tw-justify-start tw-items-center tw-w-[calc(100%_-_35px)] tw-select-none" >
          <base-icon v-if="props.icon" :icon="props.icon" class="tw-align-middle"></base-icon>
          <p class="tw-mb-0" v-if="props.multiple && Array.isArray(props.selected)">
            {{ props.selected.length > 0 ? props.selected.length + ' انتخاب شده' : props.title }}
          </p>
          <base-animated-text v-if="!props.multiple" :text="Object.values(props.options).find(x => reduce(x) === modelValue)?.label || title" :max-length="40" />
          <p v-else class="tw-mb-0" v-text="title"></p>
        </div>
        <loading-spinner size="sm" class="tw-my-auto tw-text-blue-dark-100" v-if="loading" :show="true" />
        <div v-else class="tw-overflow-hidden tw-flex tw-justify-end tw-items-center tw-relative tw-w-14 tw-h-6 max-md:tw-w-14">
          <base-icon v-if="modelValue"
                     @click="deleteValue"
                     icon="close"
                     class="tw-text-blue-dark-200 tw-p-1 md:tw-absolute tw-top-[-150%] tw-transition-all tw-duration-200 group-hover:tw-top-[-1px] hover:tw-text-red-200" size="20" />
          <base-icon icon="arrow-down"
                     :class="[
                       modelValue && 'md:tw-absolute tw-top-0 group-hover:tw-top-full'
                     ]"
                     class="tw-transition-all tw-duration-200" />
        </div>
      </div>
      <label class="tw-absolute tw-text-tiny tw-top-[-12px] tw-px-1"
             :class="[
               props.icon ? 'tw-right-[29px]' : 'tw-right-[10px]',
               floatTitleBg ? floatTitleBg : 'tw-bg-white',
             ]"
             @close="toggleDropdown"
             v-text="title"
             v-if="floatTitle && !!modelValue">
      </label>
    </CDropdownToggle>
    <CDropdownMenu class="menu !tw-min-w-full tw-w-auto tw-max-h-[60vh] tw-overflow-y-auto">
      <div class="tw-py-8 tw-text-center tw-px-4 tw-text-blue-dark-200" v-if="showAlert" v-text="showAlert"></div>

      <template v-else>
        <div class="tw-sticky tw-flex tw-top-0 tw-left-0 tw-bg-white tw tw-min-h-[50px] tw-w-full tw-items-center tw-px-3 tw-border tw-border-b-static-inputBorder"
             v-if="search_able">
          <input-ayandeh
            type="text"
            body-class="tw-flex-1"
            :transparent="true"
            icon-on-input="search"
            placeholder="جستجو..."
            v-model:value="search_value"
            @stopTyping="doSearch($event)"
          />
        </div>
        <div class="tw-py-8 tw-text-center tw-px-4 tw-text-blue-dark-200" v-if="!loading && !options.length">
          <div v-if="!!search_value">
            هیج موردی مشابه با
            <span class="tw-text-blue-dark-500 tw-font-bold">"{{ search_value }}"</span>
            یافت نشد.
          </div>
          <span v-else>هیچ موردی وجود ندارد</span>
        </div>
        <template v-else>
          <CDropdownItem v-for="opt in getItems"
                         class="!tw-py-2"
                         :class="[
                           modelValue === reduce(opt) && '!tw-bg-blue-dark-50'
                         ]"
                         :disabled="opt?.disabled || modelValue === reduce(opt) || Object.values(disabledOptions).some(x => x === reduce(opt))"
                         :key="reduce(opt)"
                         @click="selectOption(reduce(opt))">
            {{ opt.label || '-' }}
          </CDropdownItem>
          <div ref="endOfList" v-if="canLoadMore && !loading" class="tw-h-[100px] tw-grid tw-place-content-center"></div>
          <div v-else-if="loading" v-for="i in 5" class="tw-py-1 tw-px-3">
            <shine-loading width="100" />
          </div>
        </template>
      </template>

    </CDropdownMenu>
  </CDropdown>
  <p v-if="!!errorMessage" class="tw-text-red-300 tw-text-tiny tw-mb-1" v-text="errorMessage"></p>
</template>

<script setup>
import {computed, defineProps, ref} from 'vue';
import BaseIcon from "@/components/base/BaseIcon.vue";
import BaseAnimatedText from "@/components/base/BaseAnimatedText.vue";
import LoadingSpinner from "@/components/loading/LoadingSpinner.vue";
import { arabicToPersian, persianToArabic } from '@/services/more/ArabicConverter'
import InputAyandeh from "@/components/inputs/InputAyandeh.vue";
import { useIntersectionObserver } from "@vueuse/core";
import ShineLoading from "@/components/loading/ShineLoading.vue";
import Plate from "@/components/partial/Plate.vue";


const visible = ref(false);
const search_value = ref('')

const emit = defineEmits(['update:modelValue', 'change','loadMore'])
const endOfList = ref(null);

const props = defineProps({
  options: {
    type: Array,
    default: () => []
  },
  title: {
    type: String,
    default: 'انتخاب',
  },
  placeholder: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: null
  },
  modelValue: {
    type: [String, Number, null],
    default: null
  },
  selected: {
    type: [Array, String, Number, null, ''],
    default: null
  },
  multiple: {
    type: Boolean,
    default: false
  },
  floatTitle: {
    type: Boolean,
    default: false
  },
  floatTitleBg: {
    type: String,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showAlert: {
    type: String,
    default: null
  },
  errorMessage: {
    type: String,
    default: null
  },
  search_able: {
    type: Boolean,
    default: false
  },
  search_in_front: {
    type: Boolean,
    default: false
  },
  canLoadMore: {type: Boolean, default: false},
  disabledOptions: {
    type: Array,
    default: []
  },
  reduce: {
    type: Function,
    default: (opt) => opt.value
  }
})

function hide() {
  visible.value = false
}
function toggleDropdown() {
  if(disabledSelect.value) return
  visible.value = !visible.value
}

function deleteValue() {
  updateValue(null)
}

function selectOption(value) {
  if(props.multiple && Array.isArray(props.selected)) {
    const selectedArray = [...props.selected]
    const index = selectedArray.indexOf(value)
    if(index > -1) {
      selectedArray.splice(index, 1)
    } else {
      selectedArray.push(value)
    }
    updateValue(selectedArray)
  } else {
    updateValue(value)
  }
  hide()
}

function updateValue(value) {
  emit('update:modelValue', value)
  emit('change', value)
}

const getItems = computed(() => {
  if (!!search_value.value && props.options.length && props.search_in_front) {
    const persianText = arabicToPersian(search_value.value);
    const arabicText = persianToArabic(search_value.value);
    const persinanItems = props.options.filter((obj) => JSON.stringify(obj).toLowerCase().includes(persianText.toLowerCase()));
    const arabicItems = props.options.filter((obj) => JSON.stringify(obj).toLowerCase().includes(arabicText.toLowerCase()));

    return [...persinanItems, ...arabicItems].filter((v, i, a) => a.findIndex((t) => t.value === v.value) === i);
  }
  return props.options
})

const disabledSelect = computed(() => {
  return props.loading || props.disabled
})

function doSearch () {
  deleteValue()

  emit("loadMore", {
    page: 1,
    search: search_value.value,
  });
}

const { stop } = useIntersectionObserver(endOfList, ([{ isIntersecting }], observerElement) => {
  if (isIntersecting && props.canLoadMore) {
    emit("loadMore",{
      search: search_value.value,
    });
  }
});
</script>

<style scoped>

.menu {
  transform: translate(10px, 10px);
  padding-top: 0;
}
</style>
